<div class="d-flex justify-content-between" style="background-color: #F44C4C;height:60px;">
    <h5 class="mb-0 main-text text-white m-3">Log Out</h5>
    <span>
        <button class="close-icon btnn btn-close  p-0" (click)="closeDialog()"> <i class="bx bx-x"></i></button>
    </span>
</div>

<div class="content-wrapper">
    <div class="p-4">
        <div class="m-3">
            <h4 class="px-3 text-center" style="color:#F44C4C">Are You Sure</h4>
            <h4 class="px-3 text-center" style="color:#F44C4C">You Want to log out?</h4>

            <div class="row pt-4">
                <div class="col-6 p-0 pe-3">
                    <button type="submit" class="btn btn-secondary text-white w-100 py-2"
                        style="background-color: #F44C4C" (click)="closeDialog()">CANCEL
                    </button>
                </div>
                <div class="col-6 p-0 ps-2">
                    <button type="submit" class="btn btn-secondary text-white w-100 py-2"
                        style="background-color: #F44C4C" (click)="logout()"> LOG
                        OUT
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>